var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-primary mr-1",on:{"click":_vm.generateCsv}},[_vm._v(" Export CSV ")])}
var staticRenderFns = []

export { render, staticRenderFns }